import styled from 'styled-components';

import { mixins } from '../../../../../style/mixins';

export const Wrapper = styled.div(({ theme: { color } }) => ({
  backgroundColor: color.background.quaternary.default(),
  display: 'flex',
  height: '100%',
  width: '100%',
}));

export const ChildrenWrapper = styled.div(({ theme: { size } }) => ({
  height: '100%',
  padding: `${size.units(2)} 0 ${size.units(2)} ${size.units(2)}`,

  ...mixins.responsive.sm.downward({
    padding: `${size.units(5)} ${size.units(5)} ${size.units(2)} ${size.units(7)}`,
  }),
}));
